import React from 'react';
import { ErrorFallbackProps } from '@funtech-int/rival-react';

import { Button } from '@/shared/components/Button/Button';
import { withResourceFreeError } from '@/shared/components/WithResourceFreeError/withResourceFreeError';
import retryIcon from '@/shared/assets/retry.svg';

import { useI18n } from '../../hooks/useI18n';

import styles from './MovieCardContentActions.module.css';

const BUTTON_SIZE = 52;

function MovieCardContentActionsErrorBase({ resetError }: ErrorFallbackProps) {
    const i18n = useI18n();

    return (
        <div className={styles.actionsWrapper}>
            <div className={styles.actions}>
                <Button
                    name="TryAgain"
                    variant="accent"
                    size={BUTTON_SIZE}
                    startIcon={
                        <img alt="" role="presentation" src={retryIcon} className={styles.icon} />
                    }
                    className={styles.button}
                    data-test-id="ContentActions_retryButton"
                    onClick={resetError}
                >
                    {i18n('content_actions__try_again_text')}
                </Button>
            </div>
        </div>
    );
}

export const MovieCardContentActionsError = withResourceFreeError(MovieCardContentActionsErrorBase);
